import { render, staticRenderFns } from "./LicenseImageCardItem.vue?vue&type=template&id=c0524fc2&scoped=true"
import script from "./LicenseImageCardItem.vue?vue&type=script&lang=js"
export * from "./LicenseImageCardItem.vue?vue&type=script&lang=js"
import style0 from "./LicenseImageCardItem.vue?vue&type=style&index=0&id=c0524fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0524fc2",
  null
  
)

export default component.exports